<template>
  <div
    :class="[
      'tw-cursor-pointer ',
      'tw-rounded-xl tw-border-2',
      'tw-px-6 tw-py-4 tw-inline-block tw-self-auto tw-text-ap-nobel',
      'apTablet:tw-text-body-md-desktop tw-text-body-md-mobile',
      'tw-border-ap-dodger-blue tw-bg-ap-dodger-blue tw-text-white hover:tw-opacity-80',
      // 'dark:!tw-border-ap-night-rider',
      { '!tw-border-ap-gainsboro  !tw-bg-transparent !tw-text-ap-nobel !tw-cursor-not-allowed': !enable }
    ]"
    @click="enable ? emit('click'): null"
  >
    <p>{{ label }}</p>
  </div>
</template>

<script setup lang="ts">

defineProps({
  label: {
    type: String,
    default: 'Next'
  },
  enable: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(['click']);

</script>

<style scoped>
</style>